"use client"

import { useEffect, useRef, useState } from "react"

const ETF_TICKERS = [
  "$SPY",
  "$QQQ",
  "$IWM",
  "$DIA",
  "$VTI",
  "$VOO",
  "$EFA",
  "$AGG",
  "$GLD",
  "$XLF",
]

const STOCK_TICKERS = [
  "$TSLA",
  "$AAPL",
  "$MSFT",
  "$AMZN",
  "$GOOG",
  "$NVDA",
  "$META",
  "$NFLX",
  "$JPM",
  "$WMT",
]

const SPEED = 15

function TickerRow({
  tickers,
  direction,
}: {
  tickers: string[]
  direction: "left" | "right"
}) {
  const scrollRef = useRef<HTMLDivElement>(null)
  const contentRef = useRef<HTMLDivElement>(null)
  const [contentWidth, setContentWidth] = useState(0)

  useEffect(() => {
    if (contentRef.current) {
      setContentWidth(contentRef.current.scrollWidth / 2)
    }
  }, [])

  const duration = contentWidth > 0 ? contentWidth / SPEED : 20

  return (
    <div ref={scrollRef} className="flex overflow-hidden whitespace-nowrap">
      <div
        ref={contentRef}
        className="flex shrink-0"
        style={{
          animation:
            contentWidth > 0
              ? `ticker-${direction} ${duration}s linear infinite`
              : "none",
        }}
      >
        {[
          ...tickers.map((t) => ({ ticker: t, copy: "a" })),
          ...tickers.map((t) => ({ ticker: t, copy: "b" })),
        ].map(({ ticker, copy }) => (
          <span
            key={`${ticker}-${copy}`}
            className="select-none px-3 font-black text-6xl/none text-black/10 tracking-tight"
          >
            {ticker}
          </span>
        ))}
      </div>
    </div>
  )
}

const Tickers = () => (
  <div
    className="mt-auto flex select-none flex-col justify-end gap-3 pb-3"
    aria-hidden="true"
  >
    <TickerRow tickers={ETF_TICKERS} direction="right" />
    <TickerRow tickers={STOCK_TICKERS} direction="left" />
  </div>
)

export default Tickers
